var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-menu",style:({ 
    '--sidebar-width': _vm.sidebarWidth,
    '--height': _vm.height,
    '--bottom': _vm.isTotemAccessibility ? '0px' : 'auto',
    'margin-top' : _vm.isTotemAccessibility ? '0px' : '50px'
  })},[_c('table',[_c('tr',_vm._l((_vm.menus),function(item,index){return _c('td',{key:index,staticStyle:{"min-width":"200px"}},[_c('menu-item',{attrs:{"index":index,"data":item}})],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }